import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { IProductVideosGETModel, IProductVideosPOSTModel, IProductVideosPUTModel } from "../../models/product/dto/videos/product-videos.model";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class ProductVideosService {
    fullPath: string;

    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/Products`;
    }

    public get(productId: number): Observable<IProductVideosGETModel[]> {
        return this.httpClient.get<any>(`${this.fullPath}/${productId}/videos`).pipe(
            map(res => res['items'].map((dto: IProductVideosGETModel) => dto))
        )
    }

    public save(productId: number, model: IProductVideosPOSTModel): Observable<IProductVideosPOSTModel> {
        return this.httpClient.post<IProductVideosPOSTModel>(`${this.fullPath}/${productId}/videos`, model);
    }

    public update(model: IProductVideosPUTModel): Observable<IProductVideosPUTModel> {
        return this.httpClient.put<IProductVideosPUTModel>(`${this.fullPath}/${model.productId}/videos/${model.videoId}`, model);
    }

    public delete(ids: number[], productId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                productId: productId,
                videoIds: ids
            }
        };
        return this.httpClient.delete<boolean>(`${this.fullPath}/${productId}/videos`, httpOptions);
    }

    getLanguages() {
        const envLanguagesArray = this.envService.settings.languages;
        let mappedLanguageArray: {code: string; name: string}[] = [];

        envLanguagesArray.forEach(lang => {
            let languageObj = {code: '', name: ''};

            languageObj.code = lang.ico;
            languageObj.name = lang.title;

            mappedLanguageArray.push(languageObj);
        })

        return mappedLanguageArray;
    }
}